import { Injectable, ComponentFactoryResolver } from '@angular/core';
import { UserPreferenceService } from '../layout/home/services/user-preference.service';
import { HttpClient } from '@angular/common/http';
import { ResourceService } from 'sce-core';
import { NavigationService } from './navigation.service';
import { AppStorageService } from './security/app-storage.service';
import { ActivatedRoute } from '@angular/router';
import { PlatformLocation, Location } from '@angular/common';
import { UserService } from './security/user.service';
import { ModalService } from '../shared/services/modal.service';
import { FileImportService } from '../shared/services/file-import.service';

@Injectable()
export class CoreServiceRegistry {

    constructor(public userService: UserService,
        public userPreferencesService: UserPreferenceService,
        public http$: HttpClient,
        public resourceService: ResourceService,
        public navigationService: NavigationService,
        public appStorageService: AppStorageService,
        public modalService: ModalService,
        public activatedRoute: ActivatedRoute,
        public platformLocation: PlatformLocation,
        public location: Location,
        public componentFactoryResolver: ComponentFactoryResolver,
        public fileImportService: FileImportService) {}

}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/core/core-service-registry.ts